import Typography from '#components/typography/Typography';
import dayjs from 'dayjs';
import useTranslation from 'next-translate/useTranslation';
import { LivestreamState, Media } from '#types/generated/graphql-types';
import { LivestreamStartTimeLabelMap } from '#config';
import { formatLocalizedTimestamp } from '#utils/format-time';
import { getTranslatedMediaDuration } from '#utils/getMediaDuration';
import LivestreamStateDisplay from '#components/feedback/livestream-state/LivestreamState';

type Props = {
  teaserData: Media;
};

const TeaserDetailsLivestreamInfos = ({ teaserData }: Props) => {
  const { t } = useTranslation();
  const start = dayjs(teaserData.details.startDate);
  const end = dayjs(teaserData.details.endDate);
  const duration = end.diff(start);

  return (
    <div className="tw-flex tw-flex-col tw-justify-center">
      <div>
        {teaserData.details.streamState !== LivestreamState.Ended &&
          teaserData.details.streamState !== LivestreamState.Archived && (
            <>
              <Typography element="span" fontWeight="bold">
                {t(
                  LivestreamStartTimeLabelMap[teaserData.details.streamState],
                  {
                    time: dayjs(teaserData.details.startDate).format('HH:mm'),
                  }
                )}
              </Typography>
              {duration > 0 && (
                <Typography element="span">
                  {' • '}
                  {t('livestreamDurationLabel', {
                    time: formatLocalizedTimestamp(duration, t),
                  })}
                </Typography>
              )}
            </>
          )}
        {teaserData.details.streamState === LivestreamState.Archived && (
          <Typography element="span" fontWeight="bold" classes="tw-opacity-40">
            {getTranslatedMediaDuration(teaserData.mediaDuration, t)}
          </Typography>
        )}
      </div>
      <div className="tw-flex tw-mb-1.5">
        <div
          className={`tw-flex tw-flex-col tw-pr-4 ${
            teaserData.details.streamState === LivestreamState.Archived
              ? 'tw-opacity-40'
              : ''
          }`}
        >
          <Typography
            element="span"
            fontWeight="black"
            classes="tw-text-[33px] tw-leading-[32px]"
          >
            {dayjs(teaserData.details.startDate).format('DD')}
          </Typography>
          <Typography
            element="span"
            fontWeight="black"
            fontSize="large"
            classes="tw-uppercase"
          >
            {dayjs(teaserData.details.startDate).format('MMM')}
          </Typography>
        </div>
        <div className="tw-flex-col tw-line-clamp-2">
          <LivestreamStateDisplay
            streamState={teaserData.details.streamState}
            classes="tw-mr-3 tw-text-small"
          />
          <Typography element="span" fontWeight="bold" fontSize="xlarge">
            {teaserData.title}
          </Typography>
        </div>
      </div>
      {teaserData.categories?.length > 0 && (
        <Typography
          fontWeight="bold"
          fontSize="small"
          classes="tw-text-accent tw-mb-1.5"
        >
          {teaserData.categories.map((item) => item.title).join(' / ')}
        </Typography>
      )}
      <Typography fontWeight="bold" classes="tw-line-clamp-3">
        {teaserData.teaserDescription}
      </Typography>
    </div>
  );
};

export default TeaserDetailsLivestreamInfos;
